const gridItemsWrapper = document.querySelectorAll(".ourWork__wrapper");
const gridItems = document.querySelectorAll(".workSample");
const breakpoint_sm = 576;
const breakpoint_md = 800;
const breakpoint_lg = 1024;


function setGrid(){
    const windowLength = document.documentElement.clientWidth;

    if (!gridItemsWrapper) return; 
    if (!gridItems) return; 


    if(windowLength < breakpoint_md) {
        return gridItemsWrapper[0].style.gridTemplateRows = `repeat(${gridItems.length}, 228px)`;
    }
    if (windowLength >= breakpoint_md && windowLength < breakpoint_lg) {
        return gridItemsWrapper[0].style.gridTemplateRows = `repeat(auto-fit, minmax(57px, 1fr))`;
    }
    
    if (windowLength >= breakpoint_lg) {
        return gridItemsWrapper[0].style.gridTemplateRows = `repeat(auto-fit, minmax(114px, 1fr))`;
    }

}



window.onresize = setGrid;

window.addEventListener('load', setGrid)